import module from 'empresa/module.js'
import template from './template.html'

export default class EmpresaInformacionSatConfirmacionComponent {
  empresaId = undefined
  data = {}
  error = false
  resultado = {exito: false}
  procesando = false
  onClose = undefined

  constructor (EmpresaInformacionSat) {
    this.EmpresaInformacionSat = EmpresaInformacionSat
  }

  guardar () {
    if (this.procesando) return

    this.procesando = true

    let data = {
      certificado: this.data.certificado,
      certificado_key_password: this.data.certificado_key_password,
      certificado_emision: this.data.certificado_emision,
      certificado_vencimiento: this.data.certificado_vencimiento,
      proveedor_id: this.data.proveedor_id,
    }

    this.EmpresaInformacionSat.put(this.empresaId, data)
      .then(() => (this.resultado.exito = true))
      .catch((response) => (this.error = response.data, this.procesando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: this.resultado}})
  }
}

module.component('empresaInformacionSatConfirmacion', {
  controller: EmpresaInformacionSatConfirmacionComponent,
  template,
  bindings: {
    empresaId: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/informacion/sat/confirmacion/component.js